import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "../components/site/Seo";
import { PageHeader, SectionLabel } from "../components/site/Section";
import { Reveal, Stat } from "../components/site/Reveal";
import { MANIFESTO, STATS } from "../data/site";

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo title="About" description="VectorBridge Group LLC is a national workforce solutions company built for compliance, precision, and mission-critical outcomes." />
      <PageHeader
        label="A/01"
        kicker="Company"
        title="A workforce partner built for accountability."
        intro="VectorBridge Group LLC was founded on a simple premise: the organizations that carry the most consequential missions deserve talent partners who operate with the same rigor. We serve government, defense, healthcare, and commercial clients nationwide."
      />

      <section className="border-b border-border py-20 sm:py-28">
        <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <SectionLabel index="A/02">Who we are</SectionLabel>
          </div>
          <div className="space-y-6 text-lg leading-relaxed text-muted-foreground md:col-span-7">
            <Reveal><p>We are a national workforce solutions firm delivering direct hire, contingent, executive, and managed workforce programs. Our model blends deep sourcing capability with disciplined program governance.</p></Reveal>
            <Reveal delay={0.05}><p>From single-role executive searches to enterprise RPO engagements and proposal staffing for federal bids, we operate as a seamless extension of our clients' talent function — measured against outcomes, not activity.</p></Reveal>
            <Reveal delay={0.1}><p>Every engagement is grounded in the standards our most regulated clients require, so quality and compliance are never afterthoughts.</p></Reveal>
          </div>
        </div>
      </section>

      <section className="border-b border-border py-20 sm:py-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {STATS.map((s, i) => <Stat key={s.label} value={s.k} label={s.label} delay={i * 0.06} />)}
          </div>
        </div>
      </section>

      <section className="border-b border-border py-20 sm:py-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <SectionLabel index="A/03">Principles</SectionLabel>
          <div className="mt-14 divide-y divide-border border-t border-border">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.05}>
                <div className="group grid gap-4 py-10 md:grid-cols-12 md:items-baseline">
                  <span className="font-mono text-sm text-brand md:col-span-1">{m.n}</span>
                  <h3 className="font-display text-3xl tracking-tight transition-colors group-hover:text-brand md:col-span-4">{m.title}</h3>
                  <p className="max-w-xl text-muted-foreground md:col-span-7">{m.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <Link to="/contact" data-testid="about-cta" className="group mt-14 inline-flex items-center gap-2 bg-brand px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-navy">
              Work with us <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
